import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Stethoscope } from "lucide-react";
import { COACH_STATUS_LABEL, fmtDateEs } from "@/lib/physio";

const BADGE_CLS = {
  booked: "bg-blue-50 text-blue-700 border-blue-200",
  confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-cyan-50 text-cyan-700 border-cyan-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
};

// Tarjeta de solo lectura para entrenadores: próximas citas de fisioterapia de
// jugadores de SUS equipos. Sin información clínica (motivo/zona/observaciones).
export default function PhysioCoachCard({ user }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (user?.role !== "coach") return;
    api.get("/physio/coach/appointments").then((r) => setItems(r.data?.items || [])).catch(() => {});
  }, [user]);

  if (user?.role !== "coach" || items.length === 0) return null;

  return (
    <Card className="border-purple-200 shadow-sm" data-testid="physio-coach-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-black flex items-center gap-2" style={{ fontFamily: "Nunito" }}>
          <Stethoscope className="h-4 w-4 text-purple-700" /> Próximas citas de jugadores del equipo
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {items.map((a, i) => (
            <div key={i} className="flex items-center justify-between gap-2 rounded-lg border border-slate-100 px-3 py-2"
              data-testid={`physio-coach-item-${i}`}>
              <div className="min-w-0">
                <div className="text-sm font-semibold truncate">{a.player_name}</div>
                <div className="text-xs text-slate-500">{a.team_name} · {fmtDateEs(a.date)} · {a.start_time}–{a.end_time}</div>
              </div>
              <Badge variant="outline" className={BADGE_CLS[a.status] || "bg-slate-50 text-slate-600"}>
                {COACH_STATUS_LABEL[a.status] || a.status}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
